<body>
   
    <div [ngClass]="{
        'main-content': selectedPalette === 'Billcentrix',
        'main-content-modern': selectedPalette === 'Moderna',
        'main-content-violet': selectedPalette === 'Violeta'
      }">
      <app-header></app-header>
        <div class="main-image">
            <div class="text">
                <h1>{{ 'plansPreview.hero.title' | translate }}</h1>
                <p>{{ 'plansPreview.hero.subtitle' | translate }}</p>
            </div>
        </div>
        <div class="plans">
            <h1>{{ 'plansPreview.plans.title' | translate }}</h1>
            <p>{{ 'plansPreview.plans.prices' | translate }}</p>
            <app-plan-practical ></app-plan-practical>
        </div>
        <div class="background-banner">
            <div class="banner-content">
                <div class="text">
                    <h1>{{ 'plansPreview.banner.title' | translate }}</h1>
                    <p>{{ 'plansPreview.banner.description' | translate }}</p>
                </div>
                <div class="white-image">
                    
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="left">
                <p>{{ 'plansPreview.footer.copyright' | translate }}</p>
            </div>
           
        </div>
    </div>
    <!-- <div class="options-buttons">
        <button class="back-btn">Atrás</button>
        <button class="continue-btn">Seleccionar</button>
    </div> -->
</body>